<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header                                                       -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Egresos</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Comprobantes</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Comprobantes de Egreso</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ totalRecords }} comprobantes · Registro y seguimiento de transacciones salientes
      </p>
    </div>
    <a routerLink="/expense-receipts/new" class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nuevo Comprobante
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPIs                                                         -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">

    <div class="kpi-card kpi-rose">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </span>
        Total Egresos
      </div>
      <div class="kpi-value">{{ totalExpenses | currency }}</div>
      <div class="kpi-hint">Suma histórica de comprobantes</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </span>
        Último Mes
      </div>
      <div class="kpi-value">{{ lastMonthTotal | currency }}</div>
      <div class="kpi-hint">Movimientos de los últimos 30 días</div>
    </div>

    <div class="kpi-card kpi-violet">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Comprobantes
      </div>
      <div class="kpi-value">{{ totalRecords }}</div>
      <div class="kpi-hint">Total emitidos</div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                           -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <!-- Buscar -->
      <div class="col-span-12 md:col-span-4">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (input)="onFilterChange()"
            placeholder="Buscar por tercero, documento o referencia..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <!-- ID -->
      <div class="col-span-6 md:col-span-2">
        <input type="number" [(ngModel)]="filterId" (ngModelChange)="onFilterChange()" placeholder="ID #"
          class="w-full px-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400 tabular-nums">
      </div>

      <!-- Banco -->
      <div class="col-span-6 md:col-span-2">
        <p-dropdown [options]="banks" [(ngModel)]="selectedBank" (onChange)="onFilterChange()" styleClass="w-full"
          placeholder="Banco" optionLabel="bankName" optionValue="id" [showClear]="true" [filter]="true" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- Estado + Sort -->
      <div class="col-span-12 md:col-span-4 flex gap-2">
        <p-dropdown [options]="[
            {label: 'Solo Activos', value: 'active'},
            {label: 'Solo Anulados', value: 'cancelled'},
            {label: 'Todos', value: 'all'}
          ]" [(ngModel)]="selectedCancellationFilter" (onChange)="onCancellationFilterChange()"
          styleClass="flex-1" placeholder="Estado" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>

        <button (click)="toggleSortOrder()"
          class="flex-shrink-0 h-[38px] px-3 border border-slate-200 rounded-lg bg-white hover:bg-slate-50 flex items-center gap-1 text-sm text-slate-700 transition-colors"
          [title]="'Ordenar por ID ' + (sortOrder === 'desc' ? 'descendente' : 'ascendente')">
          <svg class="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path *ngIf="sortOrder === 'desc'" stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
            <path *ngIf="sortOrder === 'asc'" stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
          </svg>
          <span class="tabular-nums">ID</span>
        </button>
      </div>

      <!-- Fila 2: fechas -->
      <div class="col-span-12 md:col-span-4">
        <p-dropdown [(ngModel)]="dateType" [options]="dateTypeOptions" (onChange)="onFilterChange()" styleClass="w-full"
          placeholder="Tipo de fecha" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="startDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Desde" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="endDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Hasta" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Listado                                                      -->
  <!-- ============================================================ -->
  <div class="space-y-3">

    <!-- Empty state -->
    <div *ngIf="paginatedVouchers.length === 0"
      class="bg-white border border-dashed border-slate-300 rounded-xl p-10 text-center">
      <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
        <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
      <p class="text-sm font-medium text-slate-700">No se encontraron comprobantes</p>
      <p class="text-xs text-slate-500 mt-1">Ajustá los filtros o crea un nuevo comprobante.</p>
    </div>

    <div *ngFor="let voucher of paginatedVouchers" class="receipt-row"
      [class.is-cancelled]="voucher.isCancelled"
      [class.stripe-rose]="voucher.isCancelled"
      [class.stripe-emerald]="!voucher.isCancelled && voucher.isBankReconciled"
      [class.stripe-amber]="!voucher.isCancelled && !voucher.isBankReconciled">

      <div class="status-stripe"></div>

      <div class="p-4 space-y-3">

        <!-- Fila principal: identidad + monto -->
        <div class="flex items-start justify-between gap-4">

          <div class="min-w-0 flex-1">
            <div class="flex items-center flex-wrap gap-2">
              <a [routerLink]="['/expense-receipts/view', voucher.id]" target="_blank"
                class="inline-flex items-center gap-1.5 text-base font-semibold text-slate-900 hover:text-blue-700 transition-colors group">
                <span class="tabular-nums">#{{ voucher.id }}</span>
                <svg class="w-3.5 h-3.5 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>

              <span *ngIf="voucher.isCancelled" class="pill pill-rose">
                <i class="fas fa-ban"></i> Anulado
              </span>

              <span class="pill"
                [ngClass]="voucher.isBankReconciled ? 'pill-sky' : 'pill-neutral'"
                [title]="voucher.isBankReconciled
                  ? 'Conciliado el ' + (voucher.bankReconciledAt | date:'short') + ' por ' + voucher.bankReconciledBy
                  : 'Pendiente de conciliación bancaria'">
                <i class="fas" [ngClass]="voucher.isBankReconciled ? 'fa-check-circle' : 'fa-clock'"></i>
                {{ voucher.isBankReconciled ? 'Conciliado' : 'Sin conciliar' }}
              </span>
            </div>

            <!-- Tercero -->
            <div class="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span class="text-sm font-medium text-slate-800 flex items-center gap-1.5">
                <svg class="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {{ voucher.thirdParties.firstName }} {{ voucher.thirdParties.lastName }}
              </span>
              <span class="text-xs text-slate-400 tabular-nums">{{ getThirdPartyDocument(voucher) }}</span>
            </div>
            <p class="mt-0.5 text-xs text-slate-500 truncate">
              {{ voucher.bank.bankName }} · Cta {{ voucher.bank.accountNumber }}
            </p>
          </div>

          <!-- Monto (ancla derecha) -->
          <div class="flex-shrink-0 text-right">
            <p class="text-[11px] font-medium text-slate-400 uppercase tracking-wide">Total Pagado</p>
            <p class="text-xl font-semibold text-slate-900 tabular-nums leading-tight">
              {{ voucher.totalToPay | currency }}
            </p>
            <p *ngIf="voucher.totalDiscount > 0" class="text-[11px] text-rose-600 tabular-nums mt-0.5">
              −{{ voucher.totalDiscount | currency }} desc.
            </p>
          </div>
        </div>

        <!-- Grid de metadatos -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-3 pt-3 border-t border-slate-100">

          <div class="data-cell">
            <span class="data-label">Subtotal</span>
            <span class="data-value tabular-nums">{{ voucher.totalAmount | currency }}</span>
          </div>

          <div class="data-cell">
            <span class="data-label">Descuentos</span>
            <span class="data-value tabular-nums" [ngClass]="voucher.totalDiscount > 0 ? 'text-rose-700' : 'text-slate-500'">
              {{ voucher.totalDiscount > 0 ? '−' : '' }}{{ voucher.totalDiscount | currency }}
            </span>
          </div>

          <div class="data-cell">
            <span class="data-label">Creación</span>
            <span class="data-value tabular-nums">{{ voucher.createdAt | date:'dd/MM/yy' }}</span>
          </div>

          <div class="data-cell">
            <span class="data-label">Fecha de pago</span>
            <span class="data-value tabular-nums">{{ voucher.dateExpenseVoucher | date:'dd/MM/yy' }}</span>
          </div>
        </div>

        <!-- Órdenes asociadas -->
        <div *ngIf="voucher.expenseVouchersItems?.length"
          class="flex flex-wrap items-center gap-2 pt-2 border-t border-slate-100">
          <span class="text-[11px] font-medium text-slate-400 uppercase tracking-wider">OT pagadas:</span>
          <a *ngFor="let item of voucher.expenseVouchersItems"
            [routerLink]="['/work-orders/view', item.workOrders?.id]"
            class="pill pill-sky hover:opacity-80 transition-opacity"
            [title]="'Ver OT #' + item.workOrders?.id + ' · Pagado: ' + (item.amountPaid | currency)">
            OT #<span class="tabular-nums">{{ item.workOrders?.id }}</span>
          </a>
        </div>

        <!-- Bloque de anulación -->
        <div *ngIf="voucher.isCancelled"
          class="bg-rose-50/60 border border-rose-200 rounded-md p-3 text-sm flex items-start gap-2">
          <svg class="w-4 h-4 text-rose-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor"
            viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          <div class="flex-1 min-w-0">
            <p class="text-rose-800"><strong class="font-semibold">Motivo:</strong> {{ voucher.cancellationReason }}</p>
            <div class="flex flex-wrap justify-between gap-x-4 text-xs text-rose-600 mt-1">
              <span><strong>Por:</strong> {{ voucher.cancelledBy }}</span>
              <span><strong>Fecha:</strong> {{ voucher.cancelledAt | date:'medium' }}</span>
            </div>
          </div>
        </div>

        <!-- Auditoría -->
        <app-audit-info [auditData]="{
            createdBy: voucher.createdBy,
            createdAt: voucher.createdAt,
            updatedBy: voucher.updatedBy,
            updatedAt: voucher.updatedAt,
            deletedBy: voucher.deletedBy,
            deletedAt: voucher.deletedAt,
            isDeleted: voucher.isDeleted
          }" layout="compact" size="sm">
        </app-audit-info>

        <!-- Acciones -->
        <div class="flex flex-wrap items-center justify-end gap-1 pt-2 border-t border-slate-100">

          <button (click)="downloadPdf(voucher)" [disabled]="isDownloadingPdf[voucher.id]"
            class="row-action" title="Descargar PDF">
            <svg *ngIf="!isDownloadingPdf[voucher.id]" fill="none" viewBox="0 0 24 24"
              stroke-width="1.8" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
            <svg *ngIf="isDownloadingPdf[voucher.id]" class="animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
            <span>{{ isDownloadingPdf[voucher.id] ? 'Descargando…' : 'PDF' }}</span>
          </button>

          <a [routerLink]="['/expense-receipts/view', voucher.id]" class="row-action row-action--primary" title="Ver detalle">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
            <span>Detalle</span>
          </a>

          <ng-container *ngIf="!voucher.isCancelled">
            <span class="action-divider"></span>
            <button [disabled]="voucher.isBankReconciled"
              [title]="voucher.isBankReconciled
                ? 'No se puede anular: comprobante conciliado bancariamente el '
                  + (voucher.bankReconciledAt | date:'medium') + ' por ' + voucher.bankReconciledBy
                : 'Anular comprobante'"
              (click)="!voucher.isBankReconciled && showCancelModal(voucher)"
              class="row-action row-action--danger">
              <i class="fas fa-ban"></i>
              <span>Anular</span>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginador -->
  <div class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>

<!-- ============================================================ -->
<!-- Modal Anulación                                              -->
<!-- ============================================================ -->
<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity duration-300" (click)="onCancelCancellation()"></div>
  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
    <div class="relative transform overflow-hidden rounded-xl bg-white text-left shadow-2xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-lg">
      <div class="bg-white px-5 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-rose-100 sm:mx-0 sm:h-10 sm:w-10">
            <i class="fas fa-ban text-rose-600 text-xl"></i>
          </div>
          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
            <h3 class="text-base font-semibold leading-6 text-slate-900">¿Anular comprobante de egreso?</h3>
            <p class="text-sm text-slate-500 leading-relaxed mt-2">
              Esta acción es irreversible. El comprobante será anulado y no se incluirá en reportes ni sumas.
            </p>
            <div *ngIf="selectedVoucherForCancellation" class="mt-3 bg-slate-50 border border-slate-200 rounded-md p-3 text-sm text-slate-700 space-y-1">
              <p><span class="font-medium text-slate-500">Comprobante:</span> <span class="tabular-nums">#{{ selectedVoucherForCancellation.id }}</span></p>
              <p><span class="font-medium text-slate-500">Monto:</span> <span class="tabular-nums">{{ selectedVoucherForCancellation.netAmount | currency }}</span></p>
              <p><span class="font-medium text-slate-500">Fecha:</span> <span class="tabular-nums">{{ selectedVoucherForCancellation.createdAt | date:'mediumDate' }}</span></p>
            </div>
            <div class="mt-4">
              <label class="block text-sm font-medium text-slate-700 mb-2">Motivo de anulación <span class="text-rose-600">*</span></label>
              <textarea [(ngModel)]="cancellationReason" rows="3"
                class="w-full px-3 py-2 border border-slate-200 rounded-md focus:ring-2 focus:ring-rose-500 focus:border-rose-500 text-sm"
                placeholder="Especifique el motivo de la anulación..." maxlength="1000" required></textarea>
              <div class="mt-1 text-xs text-slate-500 text-right tabular-nums">{{ (cancellationReason.length || 0) }}/1000</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-slate-50 px-5 py-3 sm:flex sm:flex-row-reverse sm:px-6 border-t border-slate-200">
        <button type="button" class="btn btn-rose sm:ml-3" (click)="onConfirmCancellation()">
          <i class="fas fa-ban"></i> Anular comprobante
        </button>
        <button type="button" class="btn btn-secondary mt-3 sm:mt-0" (click)="onCancelCancellation()">Cancelar</button>
      </div>
    </div>
  </div>
</div>
